'use client';

import { useTranslations } from 'next-intl';
import { MouseEventHandler } from 'react';

import { getFlipsterUrl } from '@flipster/features/src/shared/urls';
import { useCopy } from '@flipster/features/src/shared/webview/clipboard';
import { IconButton } from '@flipster/react/design-system/icon-button';
import Share2Icon from '@flipster/react/icon/generated/Share2Icon';

import { GlossaryPageGlossaryTermFragment } from '../query.generated';

const ShareTermButton = ({ glossaryTerm }: { glossaryTerm: GlossaryPageGlossaryTermFragment }) => {
  const t = useTranslations();
  const copy = useCopy('Glossary link copied');
  const url = `${getFlipsterUrl()}/glossary/${glossaryTerm.slug}`;

  const onClickShareTermButton: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    if (navigator.share) {
      navigator.share({ title: document.title, url });
    } else {
      copy(url);
    }
  };

  return (
    <IconButton
      icon={<Share2Icon />}
      size='small'
      hierarchy='quaternary'
      onClick={onClickShareTermButton}
      aria-label={t('Autogen_common.r251126.s_Copy_the_term_link_to_the_clipboard')}
      css={{ pos: 'relative', ml: 2 }}
    />
  );
};

export default ShareTermButton;
